{
    "PromptDeletereport": "Sei sicuro di voler cancellare?",
    "PromptDeletereports": "Siete sicuri di voler eliminare definitivamente i rapporti selezionati?",
    "PromptEmptyrecyclebin": "Sei sicuro di voler eliminare definitivamente tutti i rapporti nel cestino?",
    "PromptRemovereport": "Sei sicuro di voler rimuovere questo rapporto?",
    "PromptReportswillbedeletedpermanently": "I rapporti saranno eliminati in modo permanente e non potranno essere ripristinati.",
    "AreYouSureDelete": "Sei sicuro di voler cancellare?",
    "AreYouSureRemove": "Sei sicuro di voler rimuovere questo rapporto?",
    "LanguagePrompt_PromptConfirm": "Confermare",
    "LanguagePrompt_PromptCancel": "Annullamento",
    "NAME": "LanguagePrompt"
}